export const CSRF_KEYNAME = 'slackapp_csrf';

export function useCsrf() {
  function set(code) {
    localStorage.setItem(CSRF_KEYNAME, code);
  }

  function check(code) {
    return localStorage.getItem(CSRF_KEYNAME) === code;
  }

  function remove() {
    localStorage.removeItem(CSRF_KEYNAME);
  }

  return {
    set,
    check,
    remove,
  };
}
